import { api } from "./api";
import { DepositoBancoResponse } from "../types/depositoBanco";

export const DepositoBancoService = {
    // Crear nuevo cambio de cierre
    crear: (data: DepositoBancoResponse) => {
        return api.post("/depositosBanco", data);
    },

    // Obtener cambios de cierre por agente
    getByCierre: (idCierre: number) => {
        return api.get(`/depositosBanco/cierre/${idCierre}`);
    },

    //USAR ESTE PARA TOMAR LAS BOLETAS PARA EL RESUMEN DEL CIERRE PARA EL ADMIN
    getByCierreAdmin: (idCierre: number) => {
        return api.get(`/depositosBanco/cierreAdmin/${idCierre}`);
    },

    // Desactivar cambio de cierre
    desactivar: (idDeposito: number) => {
        return api.put(`/depositosBanco/${idDeposito}/desactivar`);
    },

    obtener: (idAgente: number, fecha: string) => {
        return api.get(`/depositosBanco/dia/${idAgente}`, {params: {fecha: fecha}});
    },
}